export enum IType {
    Numeric = 'numeric',
    String = 'string',
    Bool = 'bool',
}

export enum IOperation {
    Eq = '==',
    NotEq = '!=',
    In = 'in',
    NotIn = 'not in',
    Gte = '>=',
    Lte = '<=',
    lt = '<',
    Gt = '>'
}

export type IAttributeName = string;

export type IAttributeValue = any[] | any;

export interface IAttributeInfo {
    label: string;
    name: IAttributeName;
    type: IType;
    priority: number;
    ops: IOperation[];
}

export interface IRule {
    attr: IAttributeName;
    value: IAttributeValue;
    op: IOperation;
    children?: IRule[];
    variable: boolean;
}
